import React from 'react';

export const DisplayContext = React.createContext({
    editRights: false,
    adminRights: false,
    filterIt: false
});